var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SpreadSheet',{ref:"spacemix",attrs:{"type":"Space Mix","downloadLink":_vm.downloadlink,"uploadLink":_vm.uploadLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }